<app-automation-builder-form-setup title="Edit">
  <ng-container middle [formGroup]="form">
    <mat-form-field>
      <mat-label>Name</mat-label>
      <input matInput formControlName="name" />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Object Type</mat-label>
      <mat-select formControlName="target_model">
        <mat-option *ngFor="let object of objects$ | async" [value]="object.name">{{ object.label }}</mat-option>
      </mat-select>
      <mat-hint
        *ngIf="automation.target_model && targetModelControlValue !== automation.target_model"
        align="start"
        class="object-type-change-hint"
        ><mat-icon>warning</mat-icon> Changing the object type will clear all triggers and actions
      </mat-hint>
    </mat-form-field>
  </ng-container>
  <ng-container bottom>
    <button mat-flat-button color="primary" [disabled]="!form.valid" (click)="save()">Ok</button>
    <button mat-flat-button (click)="cancel.emit()">Cancel</button>
  </ng-container>
</app-automation-builder-form-setup>
